import React, { Component } from 'react';
import { connect } from "react-redux";

import Slider from "rc-slider"
import { Trans } from 'react-i18next';

class MediaRating extends Component {
    constructor(props) {
        super(props);

        this.renderScore = this.renderScore.bind(this);

        this.state = {
            average: 0
        };
    }

    componentDidMount() {
        if (this.props.stakeholder.current_overlay_media_average.average > 0) {
            this.setState({
                average: this.props.stakeholder.current_overlay_media_average.average
            })
        }
    }

    componentWillReceiveProps() {
    }

    renderScore() {
        if (this.props.stakeholder.current_overlay_media_average.amount_ratings === 0) {
            return(
                <div className="overlay_block_main_media_overall_score">
                    <Trans>No Ratings Yet</Trans>
                </div>
            )
        } else if (this.props.stakeholder.current_overlay_media_average.average >= 0 && this.props.stakeholder.current_overlay_media_average.average < 25) {
            return(
                <div className="overlay_block_main_media_overall_score" style = {{color:"#F2403F"}}>
                    <Trans>Negative</Trans>
                </div>
            )
        } else if (this.props.stakeholder.current_overlay_media_average.average >= 25 && this.props.stakeholder.current_overlay_media_average.average < 50) { 
            return(
                <div className="overlay_block_main_media_overall_score" style = {{color:"#EF8D59"}}>
                    <Trans>Somewhat Negative</Trans>
                </div>
            )
        } else if (this.props.stakeholder.current_overlay_media_average.average >= 50 && this.props.stakeholder.current_overlay_media_average.average < 75) { 
            return(
                <div className="overlay_block_main_media_overall_score" style = {{color:"#EEDB74"}}>
                    <Trans>Neutral</Trans>
                </div>
            )
        } else if (this.props.stakeholder.current_overlay_media_average.average >= 75 && this.props.stakeholder.current_overlay_media_average.average < 100) { 
            return(
                <div className="overlay_block_main_media_overall_score" style = {{color:"#9DCC55"}}>
                    <Trans>Somewhat Positive</Trans>
                </div>
            )
        } else if (this.props.stakeholder.current_overlay_media_average.average === 100) { 
            return(
                <div className="overlay_block_main_media_overall_score" style = {{color:"#65C73E"}}>
                    <Trans>Positive</Trans>
                </div>
            )    
        }
    }
    
    render() {
        return(
            <div className={this.props.noHeader ? "" : "card"} style = {this.props.noHeader ? {} : {marginBottom: "1px solid #DFE3E8"}}>
                {this.props.noHeader ? null : <div className="card-divider">
                    <span className = "card-header-title"><Trans>Media Rating</Trans></span>
                </div>}
                <div className="overlay_block_main">
                    {this.renderScore()}
                    {
                        this.props.stakeholder.current_overlay_media_average.amount_ratings > 0 ?
                            <div className="overlay_block_main_media_average">
                                <Trans>Average of</Trans> {this.props.stakeholder.current_overlay_media_average.amount_ratings} Article{this.props.stakeholder.current_overlay_media_average.amount_ratings === 1 ? <span>s</span> : null}
                            </div>
                        :
                            null
                    }
                    <div className = "mediarating-slider mt-16">
                        <Slider min={0} max={100} step={25} disabled={true} dots value={this.props.stakeholder.current_overlay_media_average.average > 0 ? this.props.stakeholder.current_overlay_media_average.average : 0} handleStyle={this.props.stakeholder.current_overlay_media_average.amount_ratings === 0 ? [{display: 'none'}] : []}/>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(MediaRating)